var Browser = /* @__PURE__ */ ((Browser2) => {
  Browser2["CHROME"] = "Chrome";
  Browser2["SAFARI"] = "Safari";
  Browser2["FIREFOX"] = "Firefox";
  Browser2["EDGE"] = "Edge";
  return Browser2;
})(Browser || {});
const getBrowser = () => {
  if (typeof window === "undefined") {
    return void 0;
  }
  if (navigator.userAgent.indexOf("Chrome" /* CHROME */) != -1) {
    return "Chrome" /* CHROME */;
  } else if (navigator.userAgent.indexOf("Edge" /* EDGE */) != -1) {
    return "Edge" /* EDGE */;
  } else if (navigator.userAgent.indexOf("Firefox" /* FIREFOX */) != -1) {
    return "Firefox" /* FIREFOX */;
  } else if (navigator.userAgent.indexOf("Safari" /* SAFARI */) != -1) {
    return "Safari" /* SAFARI */;
  } else {
    return void 0;
  }
};
const isChrome = getBrowser() === "Chrome" /* CHROME */;
const isEdge = getBrowser() === "Edge" /* EDGE */;
const isFireFox = getBrowser() === "Firefox" /* FIREFOX */;
const isSafari = getBrowser() === "Safari" /* SAFARI */;
const getVersionBrowser = () => {
  if (typeof window === "undefined") {
    return void 0;
  }
  const userAgent = navigator.userAgent;
  let match = userAgent.match(/Version\/(\d+)\.(\d+)/);
  if (isChrome) {
    match = userAgent.match(/Chrome\/(\d+)/) || userAgent.match(/CriOS\/(\d+)/);
  }
  if (isFireFox) {
    match = userAgent.match(/Firefox\/(\d+)/);
  }
  if (isEdge) {
    match = userAgent.match(/Edg\/(\d+)/);
  }
  if (match) {
    const majorVersion = parseInt(match[1], 10);
    const minorVersion = parseInt(match[2], 10);
    return { majorVersion, minorVersion };
  }
  return void 0;
};
const isNotSupportRegexHasLookbehind = () => {
  const version = getVersionBrowser();
  if (!version) {
    return false;
  }
  const { majorVersion, minorVersion } = version;
  if (isChrome) {
    return majorVersion <= 61;
  }
  if (isEdge) {
    return majorVersion <= 18;
  }
  if (isFireFox) {
    return majorVersion >= 77;
  }
  if (isSafari) {
    return majorVersion < 16 || majorVersion === 16 && minorVersion <= 3;
  }
  return false;
};

export { Browser, getBrowser, getVersionBrowser, isChrome, isEdge, isFireFox, isNotSupportRegexHasLookbehind, isSafari };
